import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

export default function Animation({animationSrc, style}) {
  const container = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: container.current, // the div element
      renderer: "svg",              // render as SVG
      loop: true,                   // repeat animation
      autoplay: true,               // start automatically
      animationData: animationSrc, // your JSON data
    });

    return () => anim.destroy(); // clean up on unmount
  }, []);

  return (
    <div
      ref={container}
      style={style}
    />
  );
}